// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__Yu2wY","newChip":"styles_newChip__x0la9"};